import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import TopLevelAppErrorBoundary from 'common/components/TopLevelAppErrorBoundary';
import { FormRenderer } from 'common/compounds/FormRenderer';
import { setGuestAccessHash, setIsUpdating } from 'common/compounds/FormRenderer/actions';
import { Notification } from 'common/compounds/Notification';
import MetricsProvider from 'observability/MetricsProvider';

import { withInlineStylesAnchor } from 'utils/insertInlineStylesAnchor';

import SuiThemeProvider from '@splashthat/sui/lib/components/SuiThemeProvider';
import { closeModal, getIsInsideEditingIframe, getFormId, UNPUBLISHED_NOTIFICATION } from '../modules/splashPage';
import Container from './Form/Container';
import UnpublishedNotification from './UnpublishedNotification';
import FreemiumSplug from './FreemiumSplug';

// Decorating the SuiThemeProvider with our custom anchor element.
const ThemeProvider = withInlineStylesAnchor(SuiThemeProvider);

const App = (props) => {
    const isInline = !props.inModal;

    return (
        <TopLevelAppErrorBoundary>
            <MetricsProvider>
                <ThemeProvider>
                    <>
                        <Container isInline={isInline}>
                            <FormRenderer
                                onRequestClose={!isInline ? props.closeModal : undefined}
                                isInline={isInline}
                                formId={props.formId}
                                allowSubmit
                            />
                        </Container>

                        <FreemiumSplug />

                        {/* Loading Notification inside the iframe will duplicate
                                any of them if we are in Builder mode. */}
                        {!props.isInsideEditingIframe && (
                            <Notification
                                notificationComponents={{
                                    [UNPUBLISHED_NOTIFICATION]: UnpublishedNotification,
                                }}
                            />
                        )}
                    </>
                </ThemeProvider>
            </MetricsProvider>
        </TopLevelAppErrorBoundary>
    );
};

const mapStateToProps = (state) => ({
    isInsideEditingIframe: getIsInsideEditingIframe(state),
    formId: getFormId(state),
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            closeModal,
            setGuestAccessHash,
            setIsUpdating,
        },
        dispatch,
    );

App.propTypes = {
    inModal: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    isInsideEditingIframe: PropTypes.bool.isRequired,
    formId: PropTypes.string,
};

App.defaultProps = {
    formId: undefined,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
